import React, { Component } from 'react'
import { APIURL } from '../../../config/config'
import axios from 'axios'

export default class RenderCarButton extends Component {
  constructor (props) {
    super(props);
    this.state = {
      car_id : this.props.car.car_id,
      carLeasingList: [],
      carLeasingSum: 0,
    }
    this._loadCarLeasingSum = this._loadCarLeasingSum.bind(this)
  }
  componentDidMount () {
    this._loadCarLeasingSum();
  }

  componentWillReceiveProps(nextProps) {

    if(nextProps.carLeasingList.length > 0){
      // console.log('===nextProps car_id=' + nextProps.car.car_id)
      if(nextProps.carLeasingList[0].car_id === nextProps.car.car_id){
        // const carLeasingList = nextProps.carLeasingList;
        // this.calCarLeasing(carLeasingList)
      }
    }

    if(nextProps.car !== this.props.car) {
      this.setState({
        car_id: nextProps.car.car_id
      },()=>{
        this._loadCarLeasingSum();
      });

    }

  }

  _loadCarLeasingSum() {
    var uri =  APIURL + '/car_leasing/'+this.state.car_id;
    axios.get(uri)
      .then(res => {
        const carLeasingList = res.data;
        // console.log(carLeasingList)
        const sum = carLeasingList.reduce((prev, curr) => parseInt(prev, 10) + parseInt(curr.car_leasing_price_median,10) , 0)
        this.setState({carLeasingList: carLeasingList, carLeasingSum: sum})
      }).catch(error => {
      this.setState({carLeasingList: []})
    })
  }

  render() {
    const {buttonType, car } = this.props
    const {carLeasingSum} = this.state
    if (buttonType=== 'car-buy') {
      if(carLeasingSum > 0) {
        return (
          <button onClick={() => this.props.handleOnClick('car-buy', car)} type="button"
                  className={this.props.user_type === 'technician' ? 'hidden' : 'btn btn-success btn-sm btn-block'}
          ><i className="icon-trophy">
            &nbsp;ขายรถคันนี้</i>
          </button>
        )
      } else {
        return(
          <button onClick={() => window.alert('ไม่สามารถทำรายการขายได้ \nเนื่องจากไม่พบข้อมูลยอดจัด')}
                  type="button"
                  className={this.props.user_type === 'technician' ? 'hidden' : 'btn btn-outline-success btn-sm btn-block'}
          ><i className="icon-trophy">
            &nbsp;ขายรถคันนี้</i>
          </button>
        )
      }
    } else {
      if(carLeasingSum > 0) {
        return (
          <button onClick={() => this.props.handleOnClick('car-book', car)} type="button"
                  className={this.props.user_type === 'technician' ? 'hidden' : 'btn btn-info btn-sm btn-block'}
          >
            <i className="icon-star">
              &nbsp;จองรถคันนี้</i>
          </button>
        )
      } else {
        return (
          <button onClick={() => window.alert('ไม่สามารถทำรายการจองได้ \nเนื่องจากไม่พบข้อมูลยอดจัด')} type="button"
                  className={this.props.user_type === 'technician' ? 'hidden' : 'btn btn-outline-info btn-sm btn-block'}
          >
            <i className="icon-star">
              &nbsp;จองรถคันนี้</i>
          </button>
        )
      }
    }
  }

}